<template>
  <el-countdown class="pusher-timer" format="HH:mm:ss" :value="timestamp" @finish="refreshNuxtData('pusherConfig')" />
</template>

<script setup lang="ts">
import type { PusherConfigResponse } from '~/types/Pusher';

const TIMER_GAP = 3000; // 3 sec

const { data } = useNuxtData<PusherConfigResponse>('pusherConfig');

const timestamp = computed(() => {
  if (!data.value) {
    return;
  }

  return data.value?.betLimitResetTimestamp + TIMER_GAP;
});
</script>

<style lang="scss">
.pusher-timer {
  .el-statistic__content {
    font-family: Eczar;
    font-weight: 600;
    font-size: 20px;
    line-height: 1.2;
    color: var(--main-text-color);
  }
}
</style>
